import { render, staticRenderFns } from "./AutosaveStatus.vue?vue&type=template&id=3a71995d&scoped=true"
import script from "./AutosaveStatus.vue?vue&type=script&lang=js"
export * from "./AutosaveStatus.vue?vue&type=script&lang=js"
import style0 from "./AutosaveStatus.vue?vue&type=style&index=0&id=3a71995d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71995d",
  null
  
)

export default component.exports